import { colors } from "../../../../data/colors";
import { stdObject } from "../../../../data/types/stdObject";
import convertDate from "../../../../utils/convertDate";
import { getNextDate } from "../../../../utils/getNextDate";
import { isDateBetween } from "../../../../utils/isDateBetween";
import { toPrice } from "../../../../utils/toPrice";

export const writeSalesReport = ({
  t,
  user,
  id,
  searchValues,
  responseReportData,
  vPayments,
}: stdObject) => {
  const cSearch = searchValues.D1;
  let results = {};
  let header = [];
  if ("prevData" in responseReportData) {
    try {
      const prevData = JSON.parse(responseReportData.prevData);
      console.log("prevData", prevData);
      results = { ...prevData.results, recorded: true };
      header = prevData.header;
    } catch (error) {
      console.log("writeSalesReport error", error);
    }
  } else {
    const checkIfInDate = (cDate: string) => {
      const rangeDate1 =
        cSearch.SCHIRE.value === "" && !user.IRESUC
          ? cSearch.FECIRE.value
          : cSearch.FEC3IRE.value;
      let rangeDate2 =
        cSearch.SCHIRE.value === "" && !user.IRESUC
          ? cSearch.FECIRE.value2 === ""
            ? cSearch.FECIRE.value
            : cSearch.FECIRE.value2
          : cSearch.FEC3IRE.value;

      const hour1 =
        cSearch.SCHIRE.value === "" && !user.IRESUC
          ? "00:00:00"
          : responseReportData.time[0];
      const hour2 =
        cSearch.SCHIRE.value === "" && !user.IRESUC
          ? "23:59:59"
          : responseReportData.time[1];

      if (rangeDate1 === rangeDate2 && hour1 > hour2) {
        rangeDate2 = getNextDate(rangeDate1, 1);
      }

      return isDateBetween(
        cDate,
        `${rangeDate1} ${hour1}`,
        `${rangeDate2} ${hour2}`,
      );
    };

    let tempReportData: Array<stdObject> = [];
    let tempPay: Array<number> = [];
    let temptotals: stdObject = {};
    let counter = 0;
    let clientCounter: string[] = [];

    responseReportData.data.forEach((e: stdObject, index: number) => {
      if (!tempPay.includes(e.TIPDIN)) {
        tempPay.push(e.TIPDIN);
      }
      let show = true;
      let outDate = false;
      if (
        index > 0 &&
        responseReportData.data[index - 1].TIPO === e.TIPO &&
        responseReportData.data[index - 1].SERSEV === e.SERSEV &&
        responseReportData.data[index - 1].CODSEV === e.CODSEV
      ) {
        show = false;
      } else {
        if (!("TOTAL" in temptotals)) {
          temptotals.TOTAL = 0;
        }
        if (checkIfInDate(e.FECSEV)) {
          temptotals.TOTAL += e.TOTSEV;
          if (!clientCounter.includes(e.CLISEV)) {
            clientCounter.push(e.CLISEV);
          }
        } else {
          outDate = true;
        }
        if (!("BALANCE" in temptotals)) {
          temptotals.BALANCE = 0;
        }
        temptotals.BALANCE += e.SALSEV;
        counter++;
      }

      let tParams: stdObject = {
        DATE: show ? convertDate({ info: e.FECSEV, t }) : "",
        DOC: show ? t("c." + e.TIPO) + " " + e.SERSEV + "-" + e.CODSEV : "",
        CODE: show ? e.CLISEV : "",
        NAME: show ? e.NOMSEV : "",
        INTN: show ? e.INTN : "",
        TOTAL: show ? toPrice(e.TOTSEV) : "",
        BALANCE: show ? (e.SALSEV === 0 ? "" : toPrice(e.SALSEV)) : "",
        DATE2: convertDate({ info: e.FECDIN, t }),
        STAFF: e.NOBDIN,
        OBS: e.OBSDIN,
        BGCOLOR: counter % 2 === 0 ? colors.white : colors.lightGrey,
        style: outDate ? { color: colors.darkRed } : {},
      };
      if (typeof e.TIPDIN === "number") {
        if (!(`TPA${e.TIPDIN}` in temptotals)) {
          temptotals[`TPA${e.TIPDIN}`] = 0;
        }
        temptotals[`TPA${e.TIPDIN}`] += e.CANDIN;
        tParams[`TPA${e.TIPDIN}`] = toPrice(e.CANDIN);
      }
      tempReportData.push(tParams);
    });

    const paymentList = vPayments
      .filter((e: stdObject) => tempPay.includes(e.CODTPA))
      .map((e: stdObject) => {
        return {
          code: "TPA" + e.CODTPA,
          label: e.NOMTPA,
          align: "right",
          lineClass: true,
        };
      });

    let tempCommPay: Array<number> = [];
    responseReportData.commissions.forEach((e: stdObject, index: number) => {
      let paycoyp = 0;
      e.TPA.forEach((v: stdObject) => {
        paycoyp += v.CANDIN;
        if (
          responseReportData.commissions[index][`TPA${v.TIPDIN}`] === undefined
        ) {
          responseReportData.commissions[index][`TPA${v.TIPDIN}`] = v.CANDIN;
        } else {
          responseReportData.commissions[index][`TPA${v.TIPDIN}`] += v.CANDIN;
        }
        if (!tempCommPay.includes(v.TIPDIN)) {
          tempCommPay.push(v.TIPDIN);
        }
      });
      responseReportData.commissions[index].PAGCOYP = paycoyp;
    });

    const paymentCommList = vPayments
      .filter((e: stdObject) => tempCommPay.includes(e.CODTPA))
      .map((e: stdObject) => {
        return {
          code: "TPA" + e.CODTPA,
          label: e.NOMTPA,
          align: "right",
          lineClass: true,
        };
      });

    temptotals.payTotal = Object.keys(temptotals)
      .filter((e: string) => e.startsWith("TPA"))
      .reduce((acc: number, curr: string) => (acc += temptotals[curr]), 0);

    header = [
      { code: "DATE", label: "c.FEC", cellStyle: { whiteSpace: "nowrap" } },
      { code: "DOC", label: "c.DOC", cellStyle: { whiteSpace: "nowrap" } },
      { code: "CODE", label: "c.COD", cellStyle: { whiteSpace: "nowrap" } },
      { code: "NAME", label: "p.customer" },
      { code: "INTN", label: "c.INT", align: "center" },
      {
        code: "TOTAL",
        label: "c.TOT",
        align: "right",
        lineClass: true,
      },
      {
        code: "DATE2",
        label: "c.FEC",
        align: "center",
        cellStyle: { whiteSpace: "nowrap" },
        lineClass: true,
      },
      ...paymentList,
      {
        code: "BALANCE",
        label: "c.SAL",
        align: "right",
        lineClass: true,
      },
      { code: "STAFF", label: "c.NOB" },
      { code: "OBS", label: "c.OBS" },
    ];

    results = {
      shift: responseReportData.shift,
      recorded: false,
      date: user.IRESUC
        ? searchValues[id].FEC3IRE.value
        : [searchValues[id].FECIRE.value, searchValues[id].FECIRE.value2],
      hours: responseReportData.time,
      report: tempReportData,
      totals: temptotals,
      numCustomers: clientCounter.length,
      paymentList,
      paymentCommList,
      items: responseReportData.items,
      commissions: responseReportData.commissions.map((e: stdObject) => {
        return {
          ...e,
          TOTCOYP: toPrice(e.TOTCOYP),
          PAGCOYP: toPrice(e.PAGCOYP),
        };
      }),
      previousBalance: responseReportData.previousBalance,
      docs: responseReportData.docs.map((e: stdObject) => {
        return {
          ...e,
          items: responseReportData.docsItems.filter(
            (v: stdObject) =>
              v.DOC === e.DOC && v.SER === e.SER && v.COD === e.COD,
          ),
        };
      }),
      cash: responseReportData.cash.map((e: stdObject) => {
        return {
          ...e,
          NOMCAJ: e.TYPE === "COYP" ? `${t("c.COYP")} (${e.NOMCAJ})` : e.NOMCAJ,
          TOT: e.ENTCAJ > 0 ? e.ENTCAJ : e.SALCAJ > 0 ? -e.SALCAJ : 0,
        };
      }),
    };
  }
  if (user.IRESUC && "time" in responseReportData) {
    cSearch.HORIRE.value = responseReportData.time[0];
  }
  return {
    ...searchValues,
    [id]: {
      ...searchValues[id],
      HORIRE: cSearch.HORIRE,
      header,
      results,
    },
  };
};
